import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleTemplatePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-review-2026",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-shipping-cost-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-coupon-discount-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-warehouse-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-spreadsheet-shoes-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-spreadsheet-hoodies-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-spreadsheet-jackets-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-spreadsheet-bags-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "/basetao-spreadsheet-accessories-guide",
    element: <ArticleTemplatePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;